import React from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';

import { colors } from '../../theme';

const StyledCustomScrollBar = ({ children, color, ...props }) => {
  const styledThumb = (style, ...props) => {
    const thumbStyle = {
      backgroundColor: color,
      borderRadius: 5,
      width: 4,
    };

    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  return (
    <Scrollbars renderThumbVertical={styledThumb} {...props}>
      {children}
    </Scrollbars>
  );
};

StyledCustomScrollBar.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
};

StyledCustomScrollBar.defaultProps = {
  color: colors.white,
};

export default StyledCustomScrollBar;
